<template>
  <ul :class="`${listClasses} toggling-dropdown`">
    <AppColumnToggle
      column="show_email"
      :active="aboutFields.show_email"
      @change="handleChange"
    >
      Email
    </AppColumnToggle>
    <AppColumnToggle
      column="show_job_title"
      :active="aboutFields.show_job_title"
      @change="handleChange"
    >
      Job title
    </AppColumnToggle>
    <AppColumnToggle
      column="show_job_type"
      :active="aboutFields.show_job_type"
      @change="handleChange"
    >
      Job type
    </AppColumnToggle>
    <AppColumnToggle
      column="show_employee_id"
      :active="aboutFields.show_employee_id"
      @change="handleChange"
    >
      Employee ID
    </AppColumnToggle>
    <AppColumnToggle
      column="show_tax_info"
      :active="aboutFields.show_tax_info"
      @change="handleChange"
    >
      Tax info
    </AppColumnToggle>
    <AppColumnToggle
      column="show_location"
      :active="aboutFields.show_location"
      @change="handleChange"
    >
      Location
    </AppColumnToggle>
    <AppColumnToggle
      column="show_timezone"
      :active="aboutFields.show_timezone"
      @change="handleChange"
    >
      Member's timezone
    </AppColumnToggle>
    <template v-if="extraFields">
      <AppColumnToggle
        column="show_date_added"
        :active="aboutFields.show_date_added"
        @change="handleChange"
      >
        Date added
      </AppColumnToggle>
      <AppColumnToggle
        column="show_date_removed"
        :active="aboutFields.show_date_removed"
        @change="handleChange"
      >
        Date removed
      </AppColumnToggle>
    </template>
    <template v-if="customFields">
      <AppColumnToggle
        v-for="field in customFieldsList"
        :key="field.key"
        :column="`show_custom_${field.key}`"
        :active="customFieldVisible(field)"
        @change="handleChange"
      >
        {{ field.title }}
      </AppColumnToggle>
    </template>
  </ul>
</template>
<script>
import { mapState } from 'vuex';
import AppColumnToggle from '../AppColumnToggle.vue';

export default {
  name: 'MembersAboutFields',
  components: {
    AppColumnToggle,
  },
  props: {
    aboutFields: {
      type: Object,
      default: () => ({}),
    },
    listClasses: {
      type: String,
      default: 'pl-0 list-style-none',
    },
    extraFields: {
      type: Boolean,
      default: false,
    },
    customFields: {
      type: Boolean,
      default: false,
    },
    customVisibleByDefault: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['organization']),
    customFieldsList() {
      return this.organization.member_profile_fields;
    },
  },
  methods: {
    handleChange(payload) {
      this.$emit('change', payload);
    },
    customFieldVisible(field) {
      return this.aboutFields[`show_custom_${field.key}`] ?? this.customVisibleByDefault;
    },
  },
};
</script>
